import { all, call, delay, put, take, takeLatest } from "redux-saga/effects";
import * as movementActions from "../action/movement";
import NotificationMessage from "../utils/NotificationMessage";
import _ from "lodash"
import Helper, {
  MAX_CLEARING,
  MIN_BROKERAGE,
  STAMP_DUTY,
  STAMP_DUTY_MAX,
  STAMP_DUTY_WARRANT,
  STAMP_DUTY_WARRANT_MAX,
} from "../utils/Helper";
import { INITIAL_DATA } from "../reducers/movement";
import Constants from "../constants";
import * as commonActions from "../action/common";

function* watcherMovementListRequest({ id }) {

  try {
    // yield put(addressActions.getAddressListSuccess(data));
  } catch (error) {}
}

function* watcherNewTemplateRequest({ data }) {
  try {
    yield put(movementActions.addNewTemplateSuccess(data));
    NotificationMessage.success("Saved the template successfully");
  } catch (error) {}
}

function* watcherUpdateNewMovementRequest({ data }) {
  try {
    let formattedData = calculateTotalMarginAndMarketValue(data);
    formattedData = getActualData(formattedData);
    yield put(movementActions.putUpdateNewMovementRequestSuccess(formattedData));
  } catch (error) {}
}

function* watcherUpdateExistingMovementRequest({ data }) {
  try {
    if (!_.isEmpty(data)) {
      yield put(commonActions.getStockListSuccess({ items: [{ display_name: data.stock_name }] }));
    } else {
      yield put(commonActions.getStockListSuccess({ items: [] }));
    }
    let formattedData = calculateTotalMarginAndMarketValue(data);
    yield put(movementActions.putUpdateExistingMovementRequestSuccess(formattedData));
  } catch (error) {}
}

function getActualData(data) {
  const {
    action_type,
    amount,
    quantity,
    price,
    margin_rate,
    cap_price,
    stock_name,
    brokerage_under_rate,
    brokerage_over_rate,
    clearing_fee_rate,
    intraday_rate,
    stamp_duty,
    sst,
    market_value,
    margin_value,
    min_brokerage,
  } = data;

  if ([Constants.CASH_IN, Constants.CASH_OUT].includes(action_type)) {
    return {
      action_type,
      amount,
    };
  }

  if ([Constants.TRANSFER_IN, Constants.TRANSFER_OUT].includes(action_type)) {
    return {
      action_type,
      stock_name,
      quantity,
      price,
      margin_rate,
      cap_price,
      market_value,
      margin_value,
    };
  }
  if ([Constants.BUY_IN, Constants.SELL_OUT].includes(action_type)) {
    return {
      action_type,
      stock_name,
      quantity,
      price,
      margin_rate,
      cap_price,
      amount,
      brokerage_under_rate,
      brokerage_over_rate,
      clearing_fee_rate,
      intraday_rate,
      stamp_duty,
      sst,
      market_value,
      margin_value,
      min_brokerage,
    };
  }
}

// Add new movement action
function* watcherNewMovementRequest({ data }) {
  try {
    yield put(movementActions.addNewMovementSuccess(data));

    // set default data
    if ([Constants.SELL_OUT, Constants.BUY_IN].includes(data.action_type)) {
      yield put(
        // dont reset brokerage value
        movementActions.putUpdateNewMovementRequestSuccess({
          action_type: data.action_type,
          brokerage_under_rate: data.brokerage_under_rate,
          brokerage_over_rate: data.brokerage_over_rate,
          min_brokerage: data.min_brokerage,
          clearing_fee_rate: data.clearing_fee_rate,
          intraday_rate: data.intraday_rate,
          sst: data.sst,
        }),
      );
    } else {
      yield put(
        movementActions.putUpdateNewMovementRequestSuccess({
          action_type: data.action_type,
          ...INITIAL_DATA,
        }),
      );
    }

    // yield put(commonActions.getStockListSuccess({ items: [] }));
    NotificationMessage.success("Successfully created new action");
  } catch (error) {}
}

function calculateTotalMarginAndMarketValue(data) {
  const {
    action_type,
    cap_price = 0,
    price = 0,
    margin_rate = 0,
    brokerage_under_rate = 0,
    brokerage_over_rate = 0,
    clearing_fee_rate = 0,
    sst = 0,
    stock_name = "",
  } = data;

  const regExp = /\(([^)]+)\)/;
  const matches = regExp.exec(stock_name);
  const stockCode = _.get(matches, 1, "");

  let formattedData = data;
  let quantity = data.quantity > 0 ? data.quantity * 100 : 0;

  if (action_type !== Constants.CASH_IN || action_type !== Constants.CASH_OUT) {
    let marginValue = 0;
    if (cap_price && cap_price !== 0) {
      if (cap_price < price) {
        marginValue = quantity * cap_price * (margin_rate / 100);
      } else {
        marginValue = quantity * price * (margin_rate / 100);
      }
    } else {
      marginValue = quantity * price * (margin_rate / 100);
    }
    formattedData = {
      ...data,
      margin_value: marginValue,
      market_value: quantity * price,
    };
  }

  if ([Constants.BUY_IN, Constants.SELL_OUT].includes(action_type)) {
    if (quantity && price) {
      let amount = 0;

      let grossAmount = parseFloat(quantity * price);
      let onlineBrokerageRate = 0;

      if (grossAmount <= 100000) {
        onlineBrokerageRate = brokerage_under_rate;
      } else if (grossAmount > 100000) {
        onlineBrokerageRate = brokerage_over_rate;
      }

      let brokerage = Helper.roundToDecimals(grossAmount * (onlineBrokerageRate / 100));
      brokerage = brokerage < MIN_BROKERAGE ? MIN_BROKERAGE : brokerage;

      let clearingFee = grossAmount * (clearing_fee_rate / 100);
      clearingFee = clearingFee > MAX_CLEARING ? MAX_CLEARING : Helper.roundToDecimals(clearingFee);

      let stampDuty = 0;
      let finalStampDuty = 0;

      let stampDutyRate = 0;
      let stampDutyRateMax = 0;
      if (stockCode.length > 4) {
        stampDutyRate = STAMP_DUTY_WARRANT;
        stampDutyRateMax = STAMP_DUTY_WARRANT_MAX;
      } else {
        stampDutyRate = STAMP_DUTY;
        stampDutyRateMax = STAMP_DUTY_MAX;
      }
      let stamp_duty_charge_per1000 = stampDutyRate * 1000;

      stampDuty = grossAmount / 1000;
      stampDuty =
        stampDuty % 1 == 0
          ? parseInt(stampDuty) * stamp_duty_charge_per1000
          : parseInt(stampDuty) * stamp_duty_charge_per1000 + stamp_duty_charge_per1000;
      finalStampDuty = stampDuty > stampDutyRateMax ? stampDutyRateMax : stampDuty;

      // if (stockCode.length === 4) {
      //   stampDuty = Helpers.roundToDecimals(grossAmount * STAMP_DUTY);
      //   finalStampDuty = stampDuty > STAMP_DUTY_MAX ? STAMP_DUTY_MAX : Math.ceil(stampDuty);
      // } else {
      //   stampDuty = Helpers.roundToDecimals(grossAmount * STAMP_DUTY_WARRANT);
      //   finalStampDuty = stampDuty > STAMP_DUTY_WARRANT_MAX ? STAMP_DUTY_WARRANT_MAX : Math.ceil(stampDuty);
      // }

      let sstAmount = Helper.roundToDecimals(brokerage * (sst / 100));

      if (action_type === Constants.BUY_IN) {
        amount = grossAmount + brokerage + clearingFee + finalStampDuty + sstAmount;
      } else if (action_type === Constants.SELL_OUT) {
        amount = grossAmount - brokerage - clearingFee - finalStampDuty - sstAmount;
      }

      formattedData = {
        ...formattedData,
        amount: amount.toFixed(2),
        stamp_duty: finalStampDuty,
      };
    }
  }
  return formattedData;
}

function* watcherUpdateMovementRequest({ data, index }) {
  try {
    // let formattedData = calculateTotalMarginAndMarketValue(data);
    //
    // yield call(delay, 1000);

    yield put(movementActions.putUpdateMovementSuccess(data, index));

    NotificationMessage.success("Successfully updated action");
  } catch (error) {}
}

function* watcherDeleteMovementRequest({ id }) {

  try {
    yield put(movementActions.deleteMovementSuccess(id));

    NotificationMessage.success("Successfully delete an action");
  } catch (error) {}
}

function* watcherDeleteTemplateRequest({ id }) {

  try {
    yield put(movementActions.deleteTemplateSuccess(id));

    NotificationMessage.success("Successfully delete the template");
  } catch (error) {}
}

function* watcherImportTemplateRequest({ id } ) {

  try {
    yield put(movementActions.importTemplateSuccess(id));
    NotificationMessage.success("Successfully imported the template");
  } catch (error) {}
}

function* rootSaga() {
  yield all([
    takeLatest("UPDATE_NEW_MOVEMENT_REQUEST", watcherUpdateNewMovementRequest),
    takeLatest("UPDATE_EXISTING_MOVEMENT_REQUEST", watcherUpdateExistingMovementRequest),
    takeLatest("GET_ADDRESS_LIST_REQUEST", watcherMovementListRequest),
    takeLatest("ADD_NEW_MOVEMENT_REQUEST", watcherNewMovementRequest),
    takeLatest("DELETE_MOVEMENT_REQUEST", watcherDeleteMovementRequest),
    takeLatest("PUT_UPDATE_MOVEMENT_REQUEST", watcherUpdateMovementRequest),
    takeLatest("ADD_NEW_TEMPLATE_REQUEST", watcherNewTemplateRequest),
    takeLatest("DELETE_TEMPLATE_REQUEST", watcherDeleteTemplateRequest),
    takeLatest("IMPORT_TEMPLATE_REQUEST", watcherImportTemplateRequest),
  ]);
}

export default rootSaga;
